export class Loggning {
  static loggaTransaktion(nKoordinat: number, eKoordinat: number) {
    const body = JSON.stringify({
      northing: Math.floor(nKoordinat),
      easting: Math.floor(eKoordinat),
      transaktionsId: 'MET012',
    });

    fetch('/fsok/seam/resource/koordinatkop', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body,
    }).catch((e) => console.log('Oväntat fel i underliggande system.' + e));
  }
}
